import { useCallback } from 'react';

import { useAtom } from '@xingternal/crate-communication-root-provider';

import type { UseTrackingReturn, TrackingEvent } from './types';
export type {
  UserId,
  Events,
  OperationalTrackingEvent,
  OperationalTrackingEventWithGenericData,
  PageViewTrackingEvent,
  InteractionTrackingEvent,
  TrackingEvent,
} from './types';

export const useTracking = <T,>(page?: string): UseTrackingReturn<T> => {
  const { set, listen } = useAtom<TrackingEvent<T>>({
    key: 'tracking',
  });

  const track = useCallback((event: TrackingEvent<T>): void => {
    if (event.type === 'operational' && page) {
      event.context = {
        ...event.context,
        page,
        position: event.context?.position ?? 0,
      };
    }

    set(event);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    track,
    listen,
  };
};
